module.exports = __webpack_public_path__ + "img/key_features--controls.aad83c72.jpg";